import { EnumClaseFactura, EnumIdioma, EnumTipoFactura } from '../../api'
import { EnumSubTipoConfiguracion } from '../../api/oData/enums/enumSubTipoConfiguracion'
import { EnumTipoConfiguracion } from '../../api/oData/enums/enumTipoConfiguracion'

export default interface TemplateSettings {
  id?: number
  templateType?: EnumTipoConfiguracion
  templateSubType?: EnumSubTipoConfiguracion
  description?: string
  products?: any[]
  contractType?: any[]
  client?: any[]
  language?: EnumIdioma
  invoiceType?: EnumTipoFactura
  currentVersion?: number
  idDetail?: number
  invoiceClass?: EnumClaseFactura | null
}

export interface TemplateSettingsAdd {
  id?: number
  templateType?: EnumTipoConfiguracion
  templateSubType?: EnumSubTipoConfiguracion
  description?: string
  products?: any[]
  contractType?: any[]
  client?: any[]
  language?: EnumIdioma | null
  invoiceType?: EnumTipoFactura
  currentVersion?: number
  company?: number,
  invoiceClass?: EnumClaseFactura | null
}

export enum TemplateSettingsDataTableType {
  Templates = 1,
  Widgets
}

export enum TemplateSettingsTabs {
  TEMPLATES = 1,
  WIDGETS
}
